// extracted by mini-css-extract-plugin
export default {"noWrap":"m-pass_noWrap__+jXoz"};